import { getExchangeRate } from "@/apis/sap.api";
import Big from "big.js";
import { useEffect, useState } from "react";

// 根据币种获取汇率转换为HKD
export function usePriceToPriceHkd(price: string, currency: string) {
  const [priceHkd, setPriceHkd] = useState<string | null>(null);

  useEffect(() => {
    const calculatePriceHkd = async () => {
      if (!price || !currency) return;
      if (currency === "HKD") {
        setPriceHkd(price);
        return;
      }
      try {
        const res = await getExchangeRate(currency, "HKD");
        const rate = res.data.data;
        const priceHkd = new Big(price || 0)
          .times(new Big(rate || 0))
          .round(2)
          .toString();

        setPriceHkd(priceHkd);
      } catch {
        setPriceHkd(null);
      }
    };

    calculatePriceHkd();
  }, [price, currency]);

  return priceHkd;
}
